var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEthNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9983 4V9.91332L16.9963 12.1466L11.9983 4Z",
    fill: "#525F6B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9987 4L7 12.1466L11.9987 9.91332V4Z",
    fill: "#525F6B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9983 15.979V19.997L16.9996 13.0776L11.9983 15.979Z",
    fill: "#525F6B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9987 19.997V15.9783L7 13.0776L11.9987 19.997Z",
    fill: "#525F6B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9983 15.0485L16.9963 12.1465L11.9983 9.91455V15.0485Z",
    fill: "#525F6B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7 12.1465L11.9987 15.0485V9.91455L7 12.1465Z",
    fill: "#525F6B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEthNew);
export default __webpack_public_path__ + "static/media/ETHNew.e8941471f4912d38c2702dcda7ecc6c3.svg";
export { ForwardRef as ReactComponent };